<template>
	<BaseCard
		class="relative flex items-center gap-5 overflow-hidden py-5 pr-5 pl-20.5"
		v-hover="{ active: 'scale-95' }"
	>
		<Component :is="icon" class="absolute -top-1 left-3.25" />
		<div class="flex-1">
			<div class="text-label-primary truncate text-sm font-medium uppercase">
				{{ gamemode }}
			</div>
			<div class="text-label-secondary mt-1 text-sm">{{ desc }}</div>
		</div>
		<BaseRadio class="shrink-0" :modelValue="selected" />
	</BaseCard>
</template>
<script setup lang="ts">
import BaseCard from './BaseCard.vue'
import ClassicIcon from '@/assets/icons/classic.svg'
import SharedIcon from '@/assets/icons/shared.svg'
import JackpotIcon from '@/assets/icons/jackpot.svg'
import BaseRadio from './BaseRadio.vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	messages: {
		en: {
			shared: 'Split all the unboxings',
			classic: 'Pull the most to win',
			jackpot: 'Bigger drop – higher chances'
		},
		ru: {
			shared: 'Выигрыш делится поровну',
			classic: 'Выбей больше для победы',
			jackpot: 'Больше дроп – выше шансы'
		}
	}
})

const props = defineProps<{
	gamemode: 'classic' | 'shared' | 'jackpot'
}>()

const selected = defineModel<boolean>()

const icon = computed(() => {
	if (props.gamemode === 'jackpot') {
		return JackpotIcon
	}
	if (props.gamemode === 'shared') {
		return SharedIcon
	}

	return ClassicIcon
})

const desc = computed(() => {
	if (props.gamemode === 'jackpot') {
		return t('jackpot')
	}
	if (props.gamemode === 'shared') {
		return t('shared')
	}

	return t('classic')
})
</script>
